// Pair-endpoint snippet, raw HTTP. The reference Godot/Unity/Unreal SDKs
// all reduce to this contract; lift it straight into any engine that
// can sign a body with HMAC-SHA256 and POST JSON.

export function buildPairHttpSnippet(apiKey: string, functionsBaseUrl: string): string {
  return `# PlayerBase pairing - raw HTTP / bash
# One-off pairing handshake. The other-engine snippets above all reduce
# to the request below; lift it into any platform that can sign a body
# with HMAC-SHA256 and POST JSON.
#
# Flow:
#   1. Player taps the recruitment button in Discord -> bot DMs them a
#      short code.
#   2. Your client sends the POST below with that code.
#   3. On success, the response carries the playerToken. Persist the
#     token plus the install id alongside the install and reuse them
#     on every subsequent /events call.
#
# The install id is generated once per device and kept across re-pairs
# (don't clear it on unpair / sign-out) so the backend can correlate
# sessions from the same install.
#
# Requires: bash, curl, openssl, uuidgen (or pre-generate INSTALL_ID).

set -euo pipefail

API_KEY="${apiKey}"
PAIRING_CODE="\${1:-PASTE_CODE_HERE}"
INSTALL_ID="\${INSTALL_ID:-$(uuidgen | tr 'A-Z' 'a-z')}"

# Unquoted heredoc terminator (JSON, no quotes) so the variables expand
# inline. The body bytes here are exactly what we sign and send.
BODY=$(cat <<JSON
{"code":"$PAIRING_CODE","installId":"$INSTALL_ID"}
JSON
)

SIGNATURE=$(printf '%s' "$BODY" | openssl dgst -sha256 -hmac "$API_KEY" -binary | xxd -p -c 256)

curl -sS -X POST ${functionsBaseUrl}/pair \\
  -H "content-type: application/json" \\
  -H "x-playerbase-signature: $SIGNATURE" \\
  --data-binary "$BODY"

# Success: 200 { "playerToken": "<uuid>" }
# Errors:  401 missing_signature | invalid_signature | not_configured
#          404 invalid_code
#
# Notes:
#   * --data-binary is important - curl's plain --data strips newlines
#     on some platforms and the signature would no longer match.
#   * On Windows / Git Bash, swap "xxd -p -c 256" for
#     "od -An -tx1 | tr -d ' \\n'" if xxd is unavailable.
`;
}
